<div class="main-container">
  <div class="main-container-bg"></div>
  <div class="container">
    <div class="row mb-5 nearby-wrapper">
      <!-- map and saleslocation list-->
      <div class="col-12 col-lg-4 mb-4">
        <h3>{{ 'POI.townsNearby' | alpitranslate }}</h3>
        <ul class="town-list">
          @for (town of towns; track town) {
            <li class="m-1">
              <a
                [routerLink]="['/SKIHIREENTRY/' + town.townSlugs[translateService.currentLang]] | localize"
                >{{ town.name }}</a
              >
            </li>
          }
        </ul>
      </div>
      <div class="col-12 col-lg-8">
        @if (town) {
          <h3>{{ 'POI.mapView' | alpitranslate: { name: town.name } }}</h3>
        }
        <div class="googlemap" #map>
          @if (isBrowser) {
            <app-map
              [fixedHeight]="true"
              [height]="{ height: '400px' }"
              [zoom]="10"
              [shops]="shops"
              (selectedShop)="scrollToSelectedShop($event)"
              id="app-map" />
          }
        </div>
      </div>
    </div>
    <div class="row">
      <!-- sidebar -->
      <div class="col-12 col-lg-4">
        <app-shop-search
          #search
          (sentForm)="updateForm($event)"
          (changedPersons)="updatePersons($event)"
          (changedLocation)="updateLocation($event)"
          (changedDateRange)="updateTimerange($event)"
          (changedPromocode)="updatePromocode($event)"
          [implementationPage]="'poiPage'" />
        <div class="clearfix"></div>
        @defer (when displayDesktopElements && shops.length > 3) {
          @if (displayDesktopElements && shops.length > 3) {
            <app-shop-filter [shops]="shops" />
          }
        }

        @if (displayDesktopElements) {
          <div class="clearfix" (deferLoad)="initRatings()" #rating></div>
        }

        <div class="clearfix"></div>
        @if (town) {
          @if (town.getCrossSellingLinks(culture)) {
            <div class="ratings cross-selling">
              <strong>{{ 'POI.moreOfferings' | alpitranslate: { LOCALITY: town?.name } }}</strong>
              <ul class="cross-selling__more-offers-list">
                @for (crossSelling of town?.getCrossSellingLinks(culture) | keyvalue; track crossSelling) {
                  <li>
                    <a href="{{ crossSelling.value }}"
                      ><span>{{ 'POI.' + crossSelling.key | alpitranslate }}</span></a
                    >
                  </li>
                }
              </ul>
            </div>
          }
        }
      </div>

      <!-- shop list content -->
      <div class="col-12 col-lg-8" [style.min-height]="loading ? '6000px' : '0'">
        @defer (when displayDesktopElements) {
          @if (displayDesktopElements) {
            <div class="towns__background">
              <app-shop-sort
                (updatedSort)="sortShops($event)"
                [displayDesktopElements]="displayDesktopElements" />
            </div>
          }
        }

        <div class="product__warning">
          <p>
            <app-icon name="info" class="mr-2 pt-1" />{{
              'POI.showTownReserveEarlyEnoughInfo' | alpitranslate
            }}
          </p>
        </div>
        @if (!loading && !error) {
          <div #shopList @loadingAnimation>
            @for (
              shop of shopFilterService.filterBy(
                shops,
                shopFilterService.distance(),
                shopFilterService.activeFilters()
              );
              track shop
            ) {
              <div
                [class.topshop]="shop.isTopShop"
                [class.isTopShop]="shop.isTopShop"
                [class.isDiscountShop]="shop.isDiscountShop"
                [class.not-in-town]="!shop.inTown"
                [class.child-free]="shop.hasFreeChildren"
                [class.no-offer-available]="shop.isOfferAvailable"
                [class.unbookable]="
                  shop.unbookableReasonsFor(
                    bookingParameters.start,
                    bookingParameters.end,
                    bookingParameters.ages
                  ).length
                "
                class="the_shop_pile product clearfix"
                id="scroll-shop-{{ shop.id }}"
                [preRender]="true"
                (deferLoad)="shop.lazyshow = true">
                @if (shop.lazyshow) {
                  <app-shop
                    [bookingParameters]="bookingParameters"
                    [shop]="shop"
                    [showAdditionalElements]="showAdditionalElements"
                    [showAlpinFlexiBadge]="showFreeFlexi"
                    [userDefinedSearch]="bookingParameters.userDefinedSearch"
                    [isLoadingNewPriceData]="shopSearchHelperService.loadingInTown"
                    [isLoadingNewOutOfTownPriceData]="shopSearchHelperService.loadingOutOfTown" />
                }
              </div>
            }
          </div>
        }
        @if (loading) {
          <div class="col-lg-12 product clearfix" @loadingAnimation>
            <div class="loader-inner">
              <div class="spinner spinner--blue">
                <div class="spinner__item1"></div>
                <div class="spinner__item2"></div>
                <div class="spinner__item3"></div>
                <div class="spinner__item4"></div>
              </div>
              <p><strong ng-bind="loadingText"></strong></p>
            </div>
          </div>
        }
        @if (error && !loading) {
          <div class="col-lg-12 product clearfix">
            @if (error && !loading) {
              <a (click)="retryLoad()">{{ 'POI.tryReloadShopList' | alpitranslate }}</a>
            }
          </div>
        }

        @if (!loading) {
          <div class="show-town__offer-expire-date">
            <div class="footnote">
              {{
                'POI.offerValidFromToFootnote'
                  | alpitranslate
                    : {
                        from_date:
                          bookingParameters.start | date: ('POI.offerValidDateFormat' | alpitranslate),
                        to_date: bookingParameters.end | date: ('POI.offerValidDateFormat' | alpitranslate)
                      }
              }}
            </div>
          </div>
        }
        @if (showFreeFlexi && !loading) {
          <div class="show-town__flexi-free">
            <!-- TODO: check flexi badge date from platformservice! -->
            <div class="footnote">
              {{
                'POI.freeStornoFootnote'
                  | alpitranslate
                    : {
                        to_date: bookingParameters.end | date: ('POI.freeStornoDateFormat' | alpitranslate)
                      }
              }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
